module.exports = __webpack_public_path__ + "img/logo_horizontal_bco.09bd20b4.svg";